import { useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { useTranslation } from 'react-i18next';

const CustomActionBar = props => {
    const { onAccept, onCancel, actions, className } = props;

    const theme = useTheme();

    const { t } = useTranslation();

    if (actions == null || actions.length === 0) {
        return null;
    }

    return (
        <DialogActions className={className}>
            <Button
                variant="contained"
                onClick={() => {
                    onCancel();
                }}
                sx={{
                    backgroundColor: theme.palette.mode === "dark" ? "primary.dark" : "primary.main",
                    textTransform: "none",
                    border: theme.palette.mode === "dark" ? 1 : 0,
                    borderColor: "primary.main",
                    borderRadius: 6,
                    "&:hover": { backgroundColor: theme.palette.mode === "dark" ? "primary.dark" : "primary.main" },
                }}
            >{t("cancel")}</Button>
            <Button
                variant="contained"
                onClick={() => {
                    onAccept();
                }}
                sx={{
                    backgroundColor: theme.palette.mode === "dark" ? "primary.dark" : "primary.main",
                    textTransform: "none",
                    border: theme.palette.mode === "dark" ? 1 : 0,
                    borderColor: "primary.main",
                    borderRadius: 6,
                    "&:hover": { backgroundColor: theme.palette.mode === "dark" ? "primary.dark" : "primary.main" },
                }}
            >{t("accept")}</Button>
        </DialogActions>
    );

};

export default CustomActionBar;